<template>
  <div class="docuform activity-page">
    <div class="card-wrap">
      <DocuformCard :item="item"
                    :matter="matter"
                    :contact="contact"
                    :is-mobile="isMobile"/>
    </div>
    <div class="docuform-content-wrap">
      <DocuformContent :item="item"/>
    </div>
  </div>
</template>
<script>
import DocuformCard from "../components/DocuformCard";
import DocuformContent from "../components/DocuformContent";

export default {
  name: "DocuformView",
  components: { DocuformCard, DocuformContent },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
    matter: {
      type: Object,
      required: true,
    },
    contact: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.docuform.activity-page {
  --card-height: 128px;
  flex-direction: column;
  display: flex;
  position: relative;
  min-height: 100%;
  width: 100%;
  max-width: 100%;
  overflow: hidden;

  .card-wrap {
    height: var(--card-height);
  }

  .docuform-content-wrap {
    border-top: 1px solid $grey-color-15;
    border-bottom: 1px solid $grey-color-15;
    max-height: calc(100vh - var(--card-height));
    overflow-y: hidden;
    background-color: $core-neutral-400;
  }

}
</style>
